import { Icon } from '@material-ui/core';
import { FC, useEffect, useState } from 'react';
import {
  BodyFiveChilds,
  BodyFourChilds,
  BodyMoreChilds,
  BodyThreeChilds,
  BodyTwoChilds,
  FullscreenCont,
  Image,
  ImageNumberDisplay,
  LeftIcon,
  MainBody,
  RightIcon,
  VideoCont,
  VideoContFull,
} from './MultiMediaDisplay.styles';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
interface IMultiMediaDisplay {
  images: string[] | [];
  videos: string[] | [];
}

const MultiMediaDisplay: FC<IMultiMediaDisplay> = ({ images, videos }) => {
  const [mediaFiles, setMediaFiles] = useState<string[]>([]);
  const [fullscreen, setFullscreen] = useState(false);
  const [fullscreenIndex, setFullscreenIndex] = useState<number>(0);

  useEffect(() => {
    document.addEventListener('contextmenu', e => {
      e.preventDefault();
    });
  }, []);

  const handleChangeIndex = (index: number) => {
    setFullscreen(true);
    setFullscreenIndex(index);
  };

  const handleCloseFullscreen = () => {
    setFullscreen(false);
    setFullscreenIndex(0);
  };

  const incrementIndex = () => {
    if (fullscreenIndex >= mediaFiles.length - 1) {
      setFullscreenIndex(0);
    } else {
      setFullscreenIndex(fullscreenIndex + 1);
    }
  };

  const decrementIndex = () => {
    if (fullscreenIndex <= 0) {
      setFullscreenIndex(mediaFiles.length - 1);
    } else {
      setFullscreenIndex(fullscreenIndex - 1);
    }
  };

  useEffect(() => {
    setMediaFiles([...images, ...videos]);
  }, [images, videos]);

  const getChildren = () => {
    return (
      <>
        {images.map((url, i) => (
          <Image
            key={i}
            src={url}
            loading="lazy"
            onClick={() => handleChangeIndex(i)}
            draggable="false"
          />
        ))}
        {videos.map((url, i) => (
          <VideoCont
            key={i}
            onClick={e => {
              e.stopPropagation();
              handleChangeIndex(i + images.length);
            }}
          >
            <video
              controlsList="nodownload"
              src={url}
              controls
              draggable="false"
              style={{ height: '100%', width: '100%' }}
            />
          </VideoCont>
        ))}
      </>
    );
  };

  return (
    <>
      {mediaFiles.length === 1 ? (
        <MainBody>{getChildren()}</MainBody>
      ) : mediaFiles.length === 2 ? (
        <BodyTwoChilds>{getChildren()}</BodyTwoChilds>
      ) : mediaFiles.length === 3 ? (
        <BodyThreeChilds>{getChildren()}</BodyThreeChilds>
      ) : mediaFiles.length === 4 ? (
        <BodyFourChilds>{getChildren()}</BodyFourChilds>
      ) : mediaFiles.length === 5 ? (
        <BodyFiveChilds>{getChildren()}</BodyFiveChilds>
      ) : mediaFiles.length > 5 ? (
        <>
          <BodyMoreChilds>
            {getChildren()}
            <ImageNumberDisplay
              className="show"
              onClick={() => handleChangeIndex(4)}
            >
              <p>{mediaFiles.length - 4}+</p>
            </ImageNumberDisplay>
          </BodyMoreChilds>
        </>
      ) : (
        <></>
      )}

      {fullscreen && (
        <FullscreenCont>
          {fullscreenIndex > images.length - 1 ? (
            <VideoContFull>
              <video
                key={mediaFiles[fullscreenIndex]}
                src={mediaFiles[fullscreenIndex]}
                autoPlay
                controls
                draggable="false"
                controlsList="nodownload"
              />
            </VideoContFull>
          ) : (
            <Image
              key={mediaFiles[fullscreenIndex]}
              src={mediaFiles[fullscreenIndex]}
              loading="lazy"
              draggable="false"
            />
          )}

          <Icon className="close-icon">
            <FullscreenExitIcon onClick={() => handleCloseFullscreen()} />
          </Icon>

          <RightIcon onClick={() => incrementIndex()}>
            <KeyboardArrowRightIcon />
          </RightIcon>

          <LeftIcon onClick={() => decrementIndex()}>
            <KeyboardArrowLeftIcon />
          </LeftIcon>
          <div className="backdrop"></div>
        </FullscreenCont>
      )}
    </>
  );
};

export default MultiMediaDisplay;
